import { STORE_MATCH_STRING, CLEAR_MATCH_STRING } from "../actions/types";
const INITIAL_STATE = {
  match_string: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case STORE_MATCH_STRING:
      return { ...state, match_string: action.payload };
    case CLEAR_MATCH_STRING:
      return { ...state, match_string: null };
    default:
      return state;
  }
};
